<template>
    <div>

        <div v-if="loading" class="text-center">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>
        <div v-else>
            <vue-headful :title="'Edit Safety Hazard :: MeritEHS'"/>

            <h4 class="py-3 mb-4">
                <ol class="breadcrumb font-weight-bold m-0">
                    <li class="breadcrumb-item font-weight-light">
                        <router-link to="/jsa">
                            JSAs
                        </router-link>
                    </li>
                    <li class="breadcrumb-item font-weight-light">
                        <router-link to="/jsa#settings">
                            Settings
                        </router-link>
                    </li>
                    <li class="breadcrumb-item active">
                        <template v-if="safety_hazard_id"><i class="fa fa-edit"></i> Edit</template>
                        <template v-else><i class="fa fa-plus"></i> Add</template>
                    </li>
                </ol>
            </h4>

            <div class="row">
                <div class="col-md-8">
                    <div class="card">
                        <div class="card-body">
                            <div v-bind:class="{ 'form-group': true, 'has-error': errors.hazard_name }" class="row">
                                <label class="col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right">Hazard Name:</label>
                                <div class="col-sm-8">
                                    <input type="text" name="hazard_name" v-model="hazard.hazard_name" class="form-control" placeholder="Enter Hazard Name" />
                                    <span v-if="errors.hazard_name" class="text-danger">
                                        <span v-for="error in errors.hazard_name">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                            <div v-bind:class="{ 'form-group': true}" class="row">
                                <label class="col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right">Is Active:</label>
                                <div class="col-sm-8">
                                    <b-form-checkbox v-model="hazard.is_active" :value="1" :unchecked-value="0" plain />
                                </div>
                            </div>
                            <hr>
                            <div class="row">
                                <label class="col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right">
                                    Controls <a href="javascript:void(0)" v-on:click="hazard.controls.push('')" class="btn btn-xs btn-success" title="Add Control"><i class="fa fa-plus"></i></a>
                                </label>
                                <div class="col-sm-8">
                                    <div v-for="(control_name, index) in hazard.controls">
                                        <div v-bind:class="{ 'form-group': true, 'has-error': errors['controls.'+index] }">
                                            <div style="position: relative;">
                                                <input type="text" name="control_name" v-model="hazard.controls[index]" class="form-control" placeholder="Enter Control Name" />
                                                <a href="javascript:void(0)"
                                                        style="position: absolute; top: 9px; right: -15px;"
                                                        class="text-danger"
                                                        v-on:click="hazard.controls.splice(index, 1)"
                                                        title="Remove Control">
                                                    <i class="fa fa-times"></i>
                                                </a>
                                            </div>
                                            <span v-if="errors['controls.'+index]" class="text-danger">
                                                <span v-for="error in errors['controls.'+index]">{{ error }}</span>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <hr/>
            <button type="button" class="btn btn-success" v-on:click="saveSafetySetting(this)" :disabled="saving">
                Save Safety Hazard
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                loading: true,
                saving: false,
                safety_hazard_id: this.$route.params.id,
                hazard: {},
                errors: {},
            }
        },

        methods: {
            getErrorClass: function(attribute) {
                return {
                    'form-group has-error': this.errors[attribute],
                    'form-group': !this.errors[attribute],
                }
            },
            getSafetySetting: function() {
                //Get the data
                this.$http
                    .get('admin/safety-settings-edit' + (this.safety_hazard_id ? '/' + this.safety_hazard_id : ''))
                    .then(response => {
                        //Set all the data
                        this.hazard = response.data;
                        this.hazard.controls = this.hazard.controls.map(e => e.control_name);

                        //Set loading
                        this.loading = false;
                    })
                    .catch(response => {

                    });
            },

            saveSafetySetting: function() {
                //Show loading
                this.saving = true;

                //Reset the errors
                this.errors = {};

                //Send it
                this.$http
                .post('admin/safety-settings-edit' + (this.safety_hazard_id ? '/' + this.safety_hazard_id : ''), this.hazard)
                .then(response => {
                    //Alert the user?
                    this.$toastr.success('Safety Hazard Saved');

                    //Return to main list?
                    this.$router.push('/jsa#settings');
                })
                .catch(error => {
                    //Check for error
                    if(error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data
                    }
                })
                .then(response => {
                    //Show loading
                    this.saving = false;
                });
            }
        },

        mounted() {
            //Get the injuries
            this.getSafetySetting();
        }
    }
</script>
